// extracted by mini-css-extract-plugin
export var card_price = "index-module--card_price--78d3d";
export var loading_img = "index-module--loading_img--efa0a";
export var off_tag = "index-module--off_tag--4b921";
export var price = "index-module--price--41f44";
export var price_desc = "index-module--price_desc--313e7";
export var price_tag_unit_container = "index-module--price_tag_unit_container--f91a8";
export var price_unit = "index-module--price_unit--75849";
export var tag_unit_container = "index-module--tag_unit_container--70af8";